// extracted by css-extract-rspack-plugin
export default {"timelineBadge":"timelineBadge-k156Tt"};